import { Col, DatePicker, Row, Switch, Tag } from "antd";
import dayjs from "dayjs";
import dayjsTZ from "../../../../utils/dayjs";

const { RangePicker } = DatePicker;

/**
 * One theme pack row: date range + effect toggles.
 */
function ThemeScheduleRow({
  theme,
  onChange,
  isActive,
  isDarkMode,
}) {
  const rangeValue =
    theme.startDate && theme.endDate
      ? [dayjs(theme.startDate), dayjs(theme.endDate)]
      : null;

  const setEffect = (key, checked) => {
    onChange({
      ...theme,
      effects: { ...theme.effects, [key]: checked },
    });
  };

  return (
    <div
      className={`tema-sezonale__row ${isActive ? "tema-sezonale__row--active" : ""} ${
        isDarkMode ? "dark" : ""
      }`}
    >
      <div className="tema-sezonale__row-head">
        <span className="tema-sezonale__row-title">{theme.label}</span>
        {isActive ? <Tag color="green">Aktive tani</Tag> : null}
      </div>

      <Row gutter={[16, 12]} align="middle">
        <Col xs={24} md={12} lg={10}>
          <label className="tema-sezonale__label">Periudha</label>
          <RangePicker
            style={{ width: "100%" }}
            format="DD/MM/YYYY"
            value={rangeValue}
            onChange={(dates) => {
              if (!dates?.[0] || !dates?.[1]) {
                onChange({ ...theme, startDate: null, endDate: null });
                return;
              }
              onChange({
                ...theme,
                startDate: dates[0].format("YYYY-MM-DD"),
                endDate: dates[1].format("YYYY-MM-DD"),
              });
            }}
            allowClear
          />
        </Col>
        <Col xs={8} md={4} lg={3}>
          <label className="tema-sezonale__label">Logo</label>
          <Switch
            checked={!!theme.effects?.logo}
            onChange={(c) => setEffect("logo", c)}
            checkedChildren="Po"
            unCheckedChildren="Jo"
          />
        </Col>
        <Col xs={8} md={4} lg={3}>
          <label className="tema-sezonale__label">Overlay</label>
          <Switch
            checked={!!theme.effects?.overlay}
            onChange={(c) => setEffect("overlay", c)}
            checkedChildren="Po"
            unCheckedChildren="Jo"
          />
        </Col>
        <Col xs={8} md={4} lg={3}>
          <label className="tema-sezonale__label">Modal</label>
          <Switch
            checked={!!theme.effects?.modal}
            onChange={(c) => setEffect("modal", c)}
            checkedChildren="Po"
            unCheckedChildren="Jo"
          />
        </Col>
        <Col xs={24} md={8} lg={5}>
          <label className="tema-sezonale__label">Sot (Tirana)</label>
          <div className="tema-sezonale__hint">
            {dayjsTZ().format("DD/MM/YYYY")}
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ThemeScheduleRow;
